module.exports = __webpack_public_path__ + "img/browser-msedge-logo.4ca31b6c.png";